<template>
    <div class="checkout-remember-address">
        <div class="checkout-remember-address__card">
            <div class="checkout-remember-address__header-wrapper">
                <h2 class="checkout-remember-address__title">{{ $t("checkout.rememberAddressHeaderTitle") }}</h2>
            </div>
            <div class="checkout-address__switch-wrapper">
                <label class="switch checkout-address__toggle-wrapper">
                    <input type="checkbox" checked name="remember_payment" :value="rememberPayment">
                    <span class="checkout-address__toggle checkout-address__toggle--round"></span>
                </label>
                <div class="checkout-remember-address__switch-text">
                    {{ $t("checkout.rememberAddressSwitchLabel") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CheckoutRememberPayment",
    data() {
        return {
            rememberPayment: true,
        }
    },
};
</script>
